/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MediaUiARewindBackIcon16Regular = forwardRef('MediaUiARewindBackIcon16Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.401 2.998A1.35 1.35 0 0 1 8.5 4.12v2.144L13.4 2.998A1.35 1.35 0 0 1 15.5 4.12v7.758a1.35 1.35 0 0 1-2.099 1.123L8.5 9.735v2.144A1.35 1.35 0 0 1 6.4 13.002L.645 9.165a1.4 1.4 0 0 1 0-2.33l5.756-3.837ZM1.602 8 7 11.599V4.4L1.602 8Zm7 0L14 11.599V4.4L8.602 8Z" })));
});
